// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryService_root__2CBWx","label":"CategoryService_label__INqnI","location":"CategoryService_location__2_QJP"};